import { StrapiQueryParams, ContentType } from "@superagents/types/api";
import { stringify } from "qs";
import { EmptyObject } from "type-fest";

export function buildApiQueryParams<
  UID extends ContentType,
  CustomParams extends Record<string, unknown> = EmptyObject,
>(params: StrapiQueryParams<UID> & CustomParams) {
  return stringify(params, { encode: false });
}

export default buildApiQueryParams;
